import { globalAxiosInstance } from "../../../apiCalls/utils/axios";
import { makeRequest } from "../../../apiCalls/utils/makeRequest";
import { RawVehicleTemplate } from "../typings/RawVehicleTemplate";
import { VehicleTemplate } from "../facades/VehicleTemplate";

type GetVehiclesTemplatesResponse = {
  data: RawVehicleTemplate[];
};

export const useGetDefaultVehicleTemplates = makeRequest({
  baseUrl: process.env.REACT_APP_VEHICLES_API || "",
  buildQuery: () => "/vehicles/templates",
  axiosInstance: globalAxiosInstance,
  method: "get",
  buildParams: () => ({
    filters: "is_default_template:eq:true",
  }),
  transformResponse: ({ data }: GetVehiclesTemplatesResponse) => {
    const {
      name,
      description,
      isDefaultTemplate,
      ignitionValue,
      columns,
      tags,
      companies,
      owner,
      errorCodesMappingName,
    } = new VehicleTemplate(data[0]);

    return {
      name,
      description,
      isDefaultTemplate,
      ignitionValue,
      columns,
      tags,
      companies,
      owner,
      errorCodesMappingName,
    };
  },
});
